import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import React from "react";
import PrizeCollection from "../app/collections/prize-collections/page";

const root = createRoot(document.getElementById("prize-collection-container") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <PrizeCollection />
    </StoreProvider>
  </React.StrictMode>
);
